import React, { useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import mobile from "../../assests/img/Asset 24.png";
import email from "../../assests/img/Asset 23.png";
import logo from "../../assests/img/kior logo.svg";
import nabhlogo from "../../assests/img/nabhlogo.png";
import {
  logoutUser,
  selectIsAuthenticated,
} from "../../redux/authSlice";
import { CART_UPDATED_EVENT, getCartCount } from "../../utils/cart";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const user = useSelector((s) => s.auth.user);
  const authLoading = useSelector((s) => s.auth.isLoading);

  const [showServices, setShowServices] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [cartCount, setCartCount] = useState(getCartCount());

  useEffect(() => {
    const onCartUpdate = (e) => {
      setCartCount(e.detail?.count ?? getCartCount());
    };
    const onStorage = (e) => {
      if (e.key === "cart") setCartCount(getCartCount());
    };
    window.addEventListener(CART_UPDATED_EVENT, onCartUpdate);
    window.addEventListener("storage", onStorage);
    setCartCount(getCartCount());
    return () => {
      window.removeEventListener(CART_UPDATED_EVENT, onCartUpdate);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const handleServicesToggle = (isOpen) => setShowServices(isOpen);
  const handleDropdownItemClick = () => setShowServices(false);

  const handleViewDetails = () => {
    setExpanded(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLogout = async () => {
    handleViewDetails();
    await dispatch(logoutUser());
    navigate("/");
  };

  const goCheckout = () => {
    handleViewDetails();
    if (isAuthenticated) navigate("/checkout");
    else navigate("/login", { state: { from: "/checkout" } });
  };

  return (
    <div className="navbar_inner">
      <div className="header_top">
        <div className="coustom_container">
          <div className="header_top_left">
            <div className="d-flex align-items-center">
              <Link to="/">
                <img src={logo} alt="logo" className="logo" />
              </Link>
              <img src={nabhlogo} alt="nabhlogo" className="logo nabh-logo" />
            </div>

            <div className="header_top_right_text">
              <Link to="contact-us" className="me-3">
                Contact Us
              </Link>
              <span className="me-3">
                <img src={mobile} alt="mobile-img" />
                +91 8263000004,+91 9875964159
              </span>
              <span className="me-3">
                <img src={email} alt="email-img" className="email_img" />{" "}
                kiorhealthcare8b@gmail.com
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="header_bottom_sec">
        <div className="coustom_container">
          <div className="header_bottom">
            <Navbar
              expand="lg"
              expanded={expanded}
              className="header-navbar w-100"
            >
              <div className="header-bar">
                <Navbar.Toggle
                  aria-controls="basic-navbar-nav"
                  onClick={() => setExpanded((prev) => !prev)}
                />

                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="header-nav-links">
                    <Nav.Link
                      as={Link}
                      to="/about-us"
                      onClick={handleViewDetails}
                    >
                      ABOUT US
                    </Nav.Link>
                    <NavDropdown
                      title="SERVICES"
                      id="services-nav-dropdown"
                      className="services-dropdown"
                      show={showServices}
                      onMouseEnter={() => setShowServices(true)}
                      onMouseLeave={() => setShowServices(false)}
                      onToggle={handleServicesToggle}
                    >
                      <NavDropdown.Item
                        as={Link}
                        to="/laboratory-tests-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        Laboratory tests
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/ct-scan-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        CT Scan
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/mri-scan-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        MRI Scan
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/ultrasound-scan-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        USG Scan
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/digital-xray-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        X-Ray / BMD / Mammography
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/cardiology-tests-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        Cardiology Tests
                      </NavDropdown.Item>
                      <NavDropdown.Item
                        as={Link}
                        to="/ecg-mohali"
                        onClick={() => {
                          handleDropdownItemClick();
                          handleViewDetails();
                        }}
                      >
                        ECG EEG NCV
                      </NavDropdown.Item>
                    </NavDropdown>
                    <Nav.Link
                      as={Link}
                      to="/health-packages-mohali"
                      onClick={handleViewDetails}
                    >
                      PACKAGES
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/contact-us"
                      onClick={handleViewDetails}
                    >
                      CONTACT US
                    </Nav.Link>
                    <Nav.Link as={Link} to="/faq" onClick={handleViewDetails}>
                      FAQ
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/feedback"
                      onClick={handleViewDetails}
                    >
                      FEEDBACK
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/blogs"
                      onClick={handleViewDetails}
                    >
                      BLOGS
                    </Nav.Link>
                    {isAuthenticated && (
                      <NavDropdown title="MY ACCOUNT" id="account-nav">
                        <NavDropdown.Item
                          as={Link}
                          to="/profile"
                          onClick={handleViewDetails}
                        >
                          Profile
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/my-bookings"
                          onClick={handleViewDetails}
                        >
                          My Bookings
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/my-reports"
                          onClick={handleViewDetails}
                        >
                          My Reports
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/addresses"
                          onClick={handleViewDetails}
                        >
                          Addresses
                        </NavDropdown.Item>
                        <NavDropdown.Item
                          as={Link}
                          to="/checkout"
                          onClick={handleViewDetails}
                        >
                          Checkout
                        </NavDropdown.Item>
                      </NavDropdown>
                    )}
                  </Nav>
                </Navbar.Collapse>

                <div className="header-auth-actions">
                  <button
                    type="button"
                    id="header-cart-btn"
                    className="header-cart-btn"
                    onClick={goCheckout}
                    aria-label="Open cart"
                  >
                    <ShoppingCartOutlinedIcon fontSize="small" />
                    {cartCount > 0 && (
                      <span className="cart-badge">{cartCount}</span>
                    )}
                  </button>

                  {isAuthenticated ? (
                    <>
                      <button
                        type="button"
                        className="header-auth-btn header-auth-btn--ghost"
                        onClick={() => {
                          handleViewDetails();
                          navigate("/profile");
                        }}
                      >
                        <PersonOutlineOutlinedIcon fontSize="small" />
                        <span className="auth-label">
                          {user?.firstName || "Account"}
                        </span>
                      </button>
                      <button
                        type="button"
                        className="header-auth-btn header-auth-btn--logout"
                        onClick={handleLogout}
                        disabled={authLoading}
                      >
                        <LogoutOutlinedIcon fontSize="small" />
                        <span className="auth-label">
                          {authLoading ? "..." : "Logout"}
                        </span>
                      </button>
                    </>
                  ) : (
                    <button
                      type="button"
                      className="header-auth-btn header-auth-btn--login"
                      onClick={() => {
                        handleViewDetails();
                        navigate("/login");
                      }}
                    >
                      <LoginOutlinedIcon fontSize="small" />
                      <span className="auth-label">Login</span>
                    </button>
                  )}
                </div>
              </div>
            </Navbar>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
